// extracted by mini-css-extract-plugin
module.exports = {"otpContainer":"otpInput_otpContainer__pXqBL","input":"otpInput_input__IFILk"};